module.exports = __webpack_public_path__ + "img/credit_icon.d7d013c9.png";